import { render } from "./areaEvaTypeEchart.vue?vue&type=template&id=794274d0&scoped=true"
import script from "./areaEvaTypeEchart.vue?vue&type=script&lang=js"
export * from "./areaEvaTypeEchart.vue?vue&type=script&lang=js"

import "./areaEvaTypeEchart.vue?vue&type=style&index=0&id=794274d0&scoped=true&lang=scss"

import exportComponent from "E:\\edu-ui\\LyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-794274d0"]])

export default __exports__